// generated by docker build
export var awsPool = {
    "aws_cognito_identity_pool_id": "us-east-1:dc3acd30-d901-44d4-823c-20bb46cb2764",
    "aws_user_pools_id": "us-east-1_FGe7Hg9yp",
    "aws_user_pools_web_client_id": "rjglmddffqoutibebidhdfrti",
};
export var authDomain = "auth.architect-io.com";
export var websiteDomain = "architect-io.com";
